import DeleteAnnouncementModal from './DeleteAnnouncementModal';

export default DeleteAnnouncementModal;
